import { LaborCostSettingsFromApi } from '@sdk/labor/types/apiTypes';
import { LaborCostSettings } from 'sling-sdk/src/labor/types';
import getRealDate from 'sling-sdk/src/utils/getRealDate';

enum LaborNumericKeys {
  holidayRateMultiplier = 'holidayRateMultiplier',
  laborPercent = 'laborPercent',
  overtimeDayMultiplier = 'overtimeDayMultiplier',
  overtimeDayThreshold = 'overtimeDayThreshold',
  overtimeWeekMultiplier = 'overtimeWeekMultiplier',
  overtimeWeekThreshold = 'overtimeWeekThreshold',
  spreadOfHoursPay = 'spreadOfHoursPay',
  spreadOfHoursThreshold = 'spreadOfHoursThreshold',
}

enum LaborDateKeys {
  payrollPeriodStartDate = 'payrollPeriodStartDate',
  payrollPeriodStartDateTwo = 'payrollPeriodStartDateTwo',
}

const getSafeValue = (value?: string | number) =>
  typeof value !== 'undefined' ? Number(value) : 0;

const stringToDate = (value?: string | Date) => {
  if (!value) {
    return null;
  }

  return value instanceof Date ? value : getRealDate(value);
};

const laborSettingsFormatter = (laborSettings: LaborCostSettingsFromApi): LaborCostSettings => {
  if (!laborSettings) {
    return null;
  }

  return {
    ...laborSettings,
    [LaborNumericKeys.holidayRateMultiplier]: getSafeValue(laborSettings.holidayRateMultiplier),
    [LaborNumericKeys.laborPercent]: getSafeValue(laborSettings.laborPercent),
    [LaborNumericKeys.overtimeDayMultiplier]: getSafeValue(laborSettings.overtimeDayMultiplier),
    [LaborNumericKeys.overtimeDayThreshold]: getSafeValue(laborSettings.overtimeDayThreshold) / 60,
    [LaborNumericKeys.overtimeWeekMultiplier]: getSafeValue(laborSettings.overtimeWeekMultiplier),
    [LaborNumericKeys.overtimeWeekThreshold]:
      getSafeValue(laborSettings.overtimeWeekThreshold) / 60,
    [LaborNumericKeys.spreadOfHoursPay]: getSafeValue(laborSettings.spreadOfHoursPay),
    [LaborNumericKeys.spreadOfHoursThreshold]:
      getSafeValue(laborSettings.spreadOfHoursThreshold) / 60,
    [LaborDateKeys.payrollPeriodStartDate]: stringToDate(laborSettings.payrollPeriodStartDate),
    [LaborDateKeys.payrollPeriodStartDateTwo]: stringToDate(
      laborSettings.payrollPeriodStartDateTwo
    ),
  };
};

export default laborSettingsFormatter;
